import React from "react";
import MobileStepper from "@material-ui/core/MobileStepper";
import Button from "@material-ui/core/Button";
import StepCarouselProps from "./StepCarousel.types";
import RightArrow from "../SVG/RightArrow";
import LeftArrow from "../SVG/LeftArrow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import "./StepCarousel.scss";

const steps = [
  {
    label: "Step-1,CASING",
  },
  {
    label: "Step-2,BORING",
  },
  {
    label: "Step-3,CAGE LOWERING",
  },
  {
    label: "Step-4,TRIME LOWERING",
  },
  {
    label: "Step-5,CONCRETING",
  },
  {
    label: "Step-6,PILE FORECASTING",
  },
  {
    label: "Step-7,AREA CLEANING",
  },
];

const StepCarousel = (props: StepCarouselProps) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [maximumStep, setMaximumStep] = React.useState(0);
  const [stepListArray, setStepListArray] = React.useState<any>([]);

  //set stepnumber from the parent component
  React.useEffect(() => {
    setActiveStep(props.choosenStep);
  }, [props.choosenStep]);

  React.useEffect(() => {
    setStepListArray(props.stepList);
  }, [props.stepList]);

  React.useEffect(() => {
    setMaximumStep(props.maximumStep);
  }, [props.maximumStep]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    props.nextOrPrevStep(activeStep + 2);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      props.backToStepper();
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      props.nextOrPrevStep(activeStep);
    }
  };

  return (
    <div className="mainWrapper">
      <div
        style={{
          width: "100%",
          position: "absolute",
          top: "2.8rem",
          left: "0%",
          textAlign: "center",
        }}
      >
        <Paper elevation={0}>
          <Typography style={{ fontSize: "16px" }}>
            {stepListArray[activeStep]?.label}
          </Typography>
        </Paper>
      </div>
      <div className="mainWrapper">
        <MobileStepper
          {...props}
          variant="text"
          steps={5}
          position="static"
          style={{ backgroundColor: "white", height: "50px" }}
          activeStep={activeStep}
          nextButton={
            <Button
              size="small"
              onClick={() => handleNext()}
              disabled={activeStep === maximumStep - 1}
            >
              <RightArrow
                isActive={activeStep < maximumStep - 1 ? true : false}
              />
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={() => handleBack()}
              // disabled={activeStep === 0}
            >
              <LeftArrow isActive={activeStep >= 1 ? true : false} />
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default StepCarousel;
